import React, { Fragment } from 'react';

import { subscriber_profile_path } from '../../routes';
import { PaginationType } from '../../utils/backend-api/subscriber_directory';
import Pagination from '../BaseUI/Pagination';
import NoResultsMessage from '../shared/NoResultsMessage';
import ArticleOrBriefingFeedItem, { ArticleOrBriefing } from './ArticleOrBriefingFeedItem';

export default function Feed({
  articlesOrBriefings,
  paginationData,
  useLargeImage,
  username,
}: {
  articlesOrBriefings: ArticleOrBriefing[];
  paginationData?: PaginationType;
  useLargeImage?: boolean;
  username?: string;
}) {
  const getPath = (page: number) =>
    subscriber_profile_path(username, page === 1 ? undefined : page);

  return (
    <div>
      {articlesOrBriefings.length > 0 ? (
        <div>
          {articlesOrBriefings.map((articleOrBriefing, i) => (
            <Fragment key={`${articleOrBriefing.type}-${articleOrBriefing.id}`}>
              <ArticleOrBriefingFeedItem
                articleOrBriefing={articleOrBriefing}
                useFeaturedLayout={(i + 1) % 4 === 0}
                useLargeImage={useLargeImage}
              />
            </Fragment>
          ))}
        </div>
      ) : (
        <NoResultsMessage />
      )}
      {paginationData?.totalPages > 1 && (
        <Pagination paginationData={paginationData} getPath={getPath} />
      )}
    </div>
  );
}
